import { SectionTitle } from '@/components/Layout/SectionTitle';
import { EventDto } from '@oncolens/oncolens-ui/lib/dto/event/Event';
import React from 'react';

interface CaseRecommendationProps {
	eventData: EventDto;
}

export const CaseRecommendation = ({ eventData }: CaseRecommendationProps) => {
  return (
    <>
      <SectionTitle title="Recommendation" />
      <div className="mb-4">
        {eventData && eventData.caseRecommendation ? (
          <>
            <dl className="flex-1 mx-3">
              <div className="mb-4">
                <dd className="inline-block print:mb-4" data-cy="request-case-recommendation">{eventData?.caseRecommendation}</dd>
              </div>
              <div>
                <dt className="inline-block mr-2 font-bold">Recommendation provided by: </dt>
                <dd className="inline-block print:block print:pl-4" data-cy="request-case-provided-by">
                  {eventData?.lastUpdatedByDisplayName}
                </dd>
              </div>
              <div>
                <dt className="inline-block mr-2 font-bold">Responded on: </dt>
                <dd className="inline-block" data-cy="request-case-provided-by-date">
                  {eventData?.updatedDate && new Date(eventData?.updatedDate).toLocaleDateString()}
                </dd>
              </div>
            </dl>
          </>
        ) : (
          <div className="w-full py-8 bg-gray-100 rounded-lg">
            <p data-cy="no-recommendation" className="w-full text-center">No recommendation has been provided yet.</p>
          </div>
        )}
      </div>
    </>
  );
};
